import React, { useState, useEffect } from "react";
import {
  Modal,
  TextInput,
  Group,
  Select,
  Button,
  Grid,
  FileInput,
  Checkbox,
  Radio,
} from "@mantine/core";
import { useForm } from "@mantine/form";
import { apiWithInterceptor } from "../../../../api";

const AnswersEditModal = ({ id, opened, setOpened, element, setRefresh }) => {
  const form = useForm({
    initialValues: {
      email: element.email,
      phone_number: element.phone_number,
      name: element.name,
      status: element.status,
      confirmed: element.confirmed,
      type: element.type,
    },
  });
  const [fields, setFields] = useState([]);
  useEffect(() => {
    apiWithInterceptor
      .get(`/ticket/form/${id}`)
      .then((res) => {
        setFields(res.data.fields);
      })
      .catch((err) => {
        console.log(err);
      });
  }, [id]);

  useEffect(() => {
    const initial = fields.reduce(
      (acc, cur) => ({ ...acc, [cur.label]: element.data[cur.label] }),
      {}
    );
    initial.email = element.email;
    initial.phone_number = element.phone_number;
    initial.name = element.name;
    initial.status = element.status;
    initial.confirmed = element.confirmed;
    initial.type = element.type;
    form.setValues(initial);
  }, [fields]);

  return (
    <Modal
      title="Edit Answer"
      opened={opened}
      onClose={() => setOpened(false)}
      closeOnClickOutside={true}
    >
      <Grid>
        <Grid.Col>
          <Group
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <form
              onSubmit={form.onSubmit((values) => {
                const formData = new FormData();
                Object.keys(values).map((key) => {
                  // check for array values like (checkboxes) to send standalone so form data can accept it
                  Array.isArray(values[key])
                    ? values[key].map((element) => {
                        formData.append(key, element);
                      })
                    : formData.append(key, values[key]);
                });

                setRefresh(true);
                apiWithInterceptor
                  .patch(`/ticket/${element.id}`, formData, {
                    headers: {
                      "Content-Type": "multipart/form-data",
                    },
                  })
                  .then((res) => {
                    console.log(res);
                    setRefresh(false);
                    setOpened(false);
                  })
                  .catch((err) => {
                    console.log(err.response.data.message);
                    setRefresh(false);
                  });
              })}
            >
              <TextInput label="Email" {...form.getInputProps("email")} />
              <TextInput label="Name" {...form.getInputProps("name")} />
              <TextInput
                label="Phone Number"
                {...form.getInputProps("phone_number")}
              />
              {Object.keys(element.data ?? {}).map((key, index) => {
                let fieldType;
                let answers;
                fields.map((item) =>
                  item.label === key
                    ? ((fieldType = item.presentation),
                      (answers = item?.answers))
                    : null
                );

                switch (fieldType) {
                  case "TEXT_FIELD":
                    return (
                      <TextInput
                        key={index * 32}
                        label={key}
                        {...form.getInputProps(key)}
                      />
                    );

                  case "NUMBER_FIELD":
                    return (
                      <TextInput
                        key={index * 33}
                        label={key}
                        {...form.getInputProps(key)}
                      />
                    );

                  case "SELECT":
                    let allData = [];
                    answers.map((item) => {
                      allData = [...allData, item.field_value];
                    });
                    return (
                      <Select
                        key={index * 44}
                        label={key}
                        data={allData}
                        clearable
                        allowDeselect
                        {...form.getInputProps(key)}
                      />
                    );

                  case "FILE":
                    return (
                      <FileInput
                        key={index * 132}
                        label={key}
                        placeholder="Upload new File"
                        {...form.getInputProps(key)}
                      />
                    );

                  case "CHECKBOX":
                    return (
                      <Checkbox.Group
                        defaultValue=""
                        orientation="vertical"
                        key={index * 32}
                        label={key}
                        {...form.getInputProps(key)}
                      >
                        {answers.map((item, index) => {
                          return (
                            <Checkbox
                              key={index * 12}
                              value={item?.field_value}
                              label={item?.field_value}
                            />
                          );
                        })}
                      </Checkbox.Group>
                    );

                  case "RADIO":
                    return (
                      <Radio.Group
                        defaultValue=""
                        orientation="vertical"
                        key={index * 364}
                        label={key}
                        {...form.getInputProps(key)}
                      >
                        {answers.map((item, index) => (
                          <Radio
                            key={index * 325}
                            value={item?.field_value}
                            label={item?.field_value}
                          />
                        ))}
                      </Radio.Group>
                    );
                }
              })}
              <Select
                style={{ marginBottom: "20px" }}
                label="Status"
                allowDeselect
                value={element.status}
                data={[
                  { value: "APPROVED", label: "APPROVED" },
                  { value: "DENIED", label: "DENIED" },
                  { value: "WAITING", label: "WAITING" },
                  { value: "SENT_APPROVED", label: "SENT_APPROVED" },
                ]}
                {...form.getInputProps("status")}
              />

              <Select
                style={{ marginBottom: "20px" }}
                label="Ticket Type"
                allowDeselect
                value={element.type}
                data={[
                  { value: "VIP", label: "VIP" },
                  { value: "NORMAL", label: "NORMAL" },
                ]}
                {...form.getInputProps("type")}
              />

              <Select
                style={{ marginBottom: "20px" }}
                label="Confirmed"
                value={element.confirmed}
                allowDeselect
                data={[
                  { value: true, label: "Confirmed" },
                  { value: false, label: "Not-Confirmed" },
                ]}
                {...form.getInputProps("confirmed")}
              />

              <Button type="submit" style={{ width: "100%" }}>
                Update Answer
              </Button>
            </form>
          </Group>
        </Grid.Col>
      </Grid>
    </Modal>
  );
};

export default AnswersEditModal;
